export const padRight = (engine) => {
    select(engine, padDirection(engine,1,0));
};

export const padLeft = (engine) => {
    select(engine, padDirection(engine,-1,0));
};
export const padUp  = (engine) => {
    select(engine, padDirection(engine,0,-1));
};
export const padDown  = (engine) => {
    select(engine, padDirection(engine,0,1));
};

const select = (engine, track) => {
    if (track) {
        engine.selectTrack(engine.tracks.indexOf(track));
    }
};

const getLocation = (engine) =>  {
    let track = engine.getSelectedTrack();
    let pad = track.pad;
    
    // find out where the track is
    let trackLocation = pad.slots.indexOf(track);
    let xLocation = trackLocation % 3;
    let yLocation = Math.floor(trackLocation / 3);
    return {xLocation, yLocation};
}
 

const exists = (pad, x,y) => {
    let slots = [[0,1,2], [3,4,5], [6,7,8]];
    return pad.slots[slots[y][x]];
};

const padDirection = (engine, x, y, trackLocation=getLocation(engine), depth=0) => {
    if (depth > 16) {
        return undefined;
    }
    let slots = [[0,1,2], [3,4,5], [6,7,8]];

    let {xLocation, yLocation} = trackLocation;
    let newX = xLocation + x;
    let newY = yLocation + y;

    if (newX >= 3) {
        if (x > 0) {
            newY--;
        } else {
            newY++;
        }
        newX = 0;
    } else if (newX < 0) {
        if (x > 0) {
            newY--;
        } else {
            newY++;
        }
        newX = 2;
    }

    if (newY < 0) {
        newY = x > 0 ? 1 : 2;
        newX--;
        if (newX < 0) {
            newX = 2;
        }
    } else if (newY >=3) {
        newY = x > 0 ? 1 : 2;
        newX++;
        if (newX >= 3) {
            newX = 0;
        }
    }

    let slotNumber = slots[newY][newX];
    let pad = engine.getSelectedTrack().pad;
    let track = pad.slots[slotNumber];
    if (!track) {
        return padDirection(engine, x,y,{xLocation: newX, yLocation: newY},depth+1);
    }
    return track;
};
